module.exports = __webpack_public_path__ + "img/card6.91a86042.png";